import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import 'react';
import noop from 'lodash/fp/noop';
import MenuItemComponent from './MenuItem';
const MenuItems = ({ items, closeMenu = noop, onMouseEnter = noop }) => {
    return (_jsx(_Fragment, { children: items.map((item, index) => {
            var _a, _b;
            return (_jsx(MenuItemComponent, Object.assign({}, item, { index: (_a = item.index) !== null && _a !== void 0 ? _a : index, closeMenu: closeMenu, onMouseEnter: onMouseEnter }), (_b = item.index) !== null && _b !== void 0 ? _b : index));
        }) }));
};
export default MenuItems;
